/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';

import {AppSharedModule} from '../common/app-shared.module';
import {NotFoundPageComponent} from './not-found-page.component';
import {Api404PageComponent} from './api404-page.component';

@NgModule({
  imports: [AppSharedModule],
  declarations: [NotFoundPageComponent, Api404PageComponent],
  exports: [NotFoundPageComponent, Api404PageComponent]
})
export class ErrorsModule {
}
